function handleResourceLink (data)  {

    let category = data.articleCategory.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z-]/g, '');
    const title = data.title.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z-]/g, '');
    
    if(category === 'general'){
        category = "kb";
    }
    
    return "/resources/"+ category + "/" + title;
}
    export default handleResourceLink;